export default {
  badge: 'Prueba',
  badge_title: 'Restaurante de prueba',
  notice: 'Este es un restaurante de prueba. Los pedidos realizados aquí son solo para pruebas.',
};
